module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "line-tips"
  }, [_c('section', {
    staticClass: "txt"
  }, [_c('indicators-data-component', {
    attrs: {
      "data": _vm.lineTipsInfo
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "sanjiao"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a31332","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/operateData/components/line-tips/LineTips.vue
// module id = 649
// module chunks = 0